module.exports = __webpack_public_path__ + "media/src/website/images/logo-square-bcbd490855eca53269780ca066864835.svg";